import { render, staticRenderFns } from "./TravelEnd.vue?vue&type=template&id=54cf4420&"
import script from "./TravelEnd.vue?vue&type=script&lang=ts&"
export * from "./TravelEnd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports